import { merge } from 'lodash';
import ReactApexChart from 'react-apexcharts';
// material
import { Box, Card, CardHeader } from '@mui/material';
// utils
import { fNumber } from '../../utils/formatNumber';
//
import { BaseOptionChart } from './BaseOptionChart';

import faker from 'faker';
// ----------------------------------------------------------------------

const CHART_DATA = [{ data: [400, 540, 580, 690, 1100, 1200, 1380] }];

export default function AtividadeUtentes() {
  const chartOptions = merge(BaseOptionChart(), {
    tooltip: {
      marker: { show: false },
      y: {
        formatter: (seriesName) => fNumber(seriesName),
        title: {
          formatter: (seriesName) => `N.º de Sessões: `
        }
      }
    },
    plotOptions: {
      bar: { 
            horizontal: true,
            barHeight: '50%',
            borderRadius: 3
          }
    },
    xaxis: {
      categories: [
        faker.name.findName(), faker.name.findName(),faker.name.findName(),faker.name.findName(),faker.name.findName(),faker.name.findName(),faker.name.findName()
      ],
      title: {
        text: "N.º de Sessões realizadas",
    }
    }
  });

  return (
    <Card>
      <CardHeader title="Atividade dos Utentes" subheader="" />
      <Box sx={{ mx: 1.5 }} dir="ltr">
        <ReactApexChart type="bar" series={CHART_DATA} options={chartOptions} height={280} />
      </Box>
    </Card>
  );
}
